import React, { forwardRef } from "react"
import { TextColorVariantProps, textColorVariants } from "../../styles"
import { classNames } from "../../utils"
import { Slot, SlotProps } from "../Slot"

export type BlockProps = Omit<SlotProps<"div">, "width" | "height"> &
  TextColorVariantProps

/**
 * A `Slot` that displays a `div` by default.
 * Also includes text color variants.
 */
export const Block = forwardRef<HTMLDivElement, BlockProps>(function Block(
  { asChild, color, className, ...rest },
  ref,
) {
  const Comp = asChild ? Slot : "div"

  return (
    <Comp
      className={classNames(textColorVariants({ color }), className)}
      ref={ref}
      {...rest}
    />
  )
})
